export default __webpack_public_path__ + "static/media/20191013_150503__01.cd4805b6.jpg";